import React from "react";
import { withRouter } from "react-router-dom";
// https://reacttraining.com/react-router/web/guides/scroll-restoration/scroll-to-top
class ScrollToTop extends React.Component {
  componentDidMount() {
    this.handleScroll();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
    // To check if youre on the same page and try to scroll to the same link again
    if (
      this.props.location &&
      this.props.location.hash &&
      this.props.location.hash === prevProps.location.hash &&
      this.props.location.key !== prevProps.location.key
    ) {
      this.handleScroll();
    }
  }

  handleScroll() {
    if (this.props.location && this.props.location.hash) {
      let hash = this.props.location.hash.replace("#", "");
      var myEle = document.getElementById(hash);
      if (myEle) {
        let top = myEle.offsetTop;
        window.scrollTo(0, top);
      }
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
